// extracted by mini-css-extract-plugin
var _1 = "Checkbox__blue--t94At";
var _2 = "Checkbox__box--iA9sD";
var _3 = "Checkbox__boxImg--qcpjx";
var _4 = "Checkbox__check--xyypF";
var _5 = "Checkbox__demo--PZchr Checkbox__mainOffice--AdaS8 Checkbox__main--md2PE CoreGeneral__textSizeC--e8OEt";
var _6 = "Checkbox__disabled--icgg3";
var _7 = "Checkbox__errored--d0v9z";
var _8 = "Checkbox__grayBox--X8y8B Checkbox__box--iA9sD";
var _9 = "Checkbox__main--md2PE";
var _a = "Checkbox__mainOffice--AdaS8 Checkbox__main--md2PE CoreGeneral__textSizeC--e8OEt";
var _b = "Checkbox__mainTrainer--Omgdg Checkbox__main--md2PE";
var _c = "Checkbox__noPointer--rTqMN";
var _d = "Checkbox__noTextHover--glH4w";
var _e = "Checkbox__trainerBox--VRBBJ";
var _f = "Checkbox__yellow-active-color--qLTfz Checkbox__mainOffice--AdaS8 Checkbox__main--md2PE CoreGeneral__textSizeC--e8OEt";
export { _1 as "blue", _2 as "box", _3 as "boxImg", _4 as "check", _5 as "demo", _6 as "disabled", _7 as "errored", _8 as "grayBox", _9 as "main", _a as "mainOffice", _b as "mainTrainer", _c as "noPointer", _d as "noTextHover", _e as "trainerBox", _f as "yellow-active-color" }
